function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "37.072%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F0F0F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F0F0F5"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  fillRule: "nonzero",
  stroke: "#BEBFCB",
  d: "M23.7 31.5v-6.319a2.018 2.018 0 0 1-1.126-3.15l3.058-4.16a2.5 2.5 0 0 1 4.013-.02l.055.073V2A1.5 1.5 0 0 0 28.2.5h-26A1.5 1.5 0 0 0 .7 2v28a1.5 1.5 0 0 0 1.5 1.5h21.5z",
  transform: "translate(.8)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#498FFF",
  d: "M25 26v6H2.217C1.545 32 1 31.534 1 30.96V26h24zM21.84 2c.64 0 1.16.52 1.16 1.16v7.68c0 .64-.52 1.16-1.16 1.16H10.16C9.52 12 9 11.48 9 10.84V3.16C9 2.52 9.52 2 10.16 2h11.68zm-4.836 2H15v1.998h-2V8h1.996L15 10h2.004V8H19V5.998h-2L17.004 4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#003A79",
  d: "M19.193 16c.446 0 .807.398.807.889V32h-8V16.889c0-.491.361-.889.807-.889h6.386zM8.18 16a.82.82 0 0 1 .82.82v2.36a.82.82 0 0 1-.82.82H5.82a.82.82 0 0 1-.82-.82v-2.36a.82.82 0 0 1 .82-.82h2.36zm18.06 0a.76.76 0 0 1 .753.656l.007.103c-.673.365-1.643 1.721-2.753 3.241h-.427a.82.82 0 0 1-.82-.82v-2.36a.82.82 0 0 1 .82-.82h2.42z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D01E29",
  d: "M25.323 23.44H26.5V31a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-7.56h1.195c.234 0 .381-.208.264-.373l-2.73-3.945a.319.319 0 0 0-.257-.122.313.313 0 0 0-.25.122l-2.7 3.945c-.08.165.066.374.301.374z"
}));

var SvgImportacaoDeCnes = function SvgImportacaoDeCnes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImportacaoDeCnes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/importacao-de-cnes.6eb8b571.svg";
export { ForwardRef as ReactComponent };